import * as React from 'react';
export const GUSvg = React.forwardRef(function GUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.5 2.5H14A1.5 1.5 0 0 1 15.5 4v8a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 12V4A1.5 1.5 0 0 1 2 2.5h.5Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 3.5c-4 3-4 6 0 9 4-3 4-6 0-9Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.61 10.5c.37.42.83.83 1.39 1.25.5-.37.97-.79 1.39-1.25H6.6Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.78 9.25c.18.42.46.83.83 1.25H9.4c.37-.42.65-.83.83-1.25H5.78Z',
      fill: '#217AB7',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.12 6.12c-.4.62-.61 1.23-.62 1.84v.08c0 .4.1.8.28 1.21h4.44c.18-.4.27-.8.28-1.21v-.08c0-.61-.22-1.22-.63-1.83H6.13Z',
      fill: '#45B2E8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 4.25a7.94 7.94 0 0 0-1.88 1.87h3.76A7.94 7.94 0 0 0 8 4.25Z',
      fill: '#24B47E',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.5 6.12h1v3.13h-1V6.12Z',
      fill: '#E25950',
    }),
  );
});
GUSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var GU = {
  category: 'flag',
  colorable: false,
  name: 'GU',
  svg: GUSvg,
};
